/*
 * @Author: Teemo Ding
 * @Date: 2022-04-21 13:19:35
 * @LastEditTime: 2022-06-06 14:26:42
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsDetail/Components/ConfigDrawer/index.tsx
 */
import { Button, Drawer, Input } from '@/src/components/Antd';
import { OriCheckbox } from '@/src/components/Antd/Checkbox/Checkbox';
import { Icon } from '@/src/tools/icon';
import { cloneDeep } from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from './css.module.less';
const OriCheckboxGroup = OriCheckbox.Group;

const ConfigDrawer = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { text, value, onChange, disabled } = props;
  const [visible, setVisible] = useState(false);
  const [valueList, setValueList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  useEffect(() => {
    setValueList(value);
    const checked = (value || [])
      .filter((o) => o.checked)
      .map((item) => item.header);

    setCheckedList(checked);
  }, [value]);

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
    const checked = (value || [])
      .filter((o) => o.checked)
      .map((item) => item.header);

    setCheckedList(checked);
    setValueList(value);
  };

  const handleOnSelectAll = () => {
    const v = (value || []).map((item) => item.header);
    setCheckedList(v);
  };

  const handleApply = () => {
    const data = value.map((item) => ({
      ...item,
      checked: checkedList.includes(item.header),
    }));
    onChange(data);
    onClose();
  };

  const handleOnChange = (inputValue) => {
    if (inputValue) {
      const str = ['', ...inputValue.toLowerCase(), ''].join('.*');
      const reg = new RegExp(str);
      const newData = value.filter((item) =>
        reg.test(item.header.toLowerCase()),
      );
      setValueList(newData);
    } else {
      setValueList(value);
    }
  };
  const handleCheckChange = (value) => {
    let checkedListClone = cloneDeep(checkedList);
    if (checkedList.includes(value)) {
      checkedListClone = checkedListClone.filter((o) => o !== value);
    } else {
      checkedListClone.push(value);
    }
    setCheckedList(checkedListClone);
  };

  const drawerFooter = (
    <div className={css.footer}>
      <Button onClick={onClose}>{getI18n('general.cancel')}</Button>
      <Button onClick={handleOnSelectAll}>
        {getI18n('general.selectAll')}
      </Button>
      <Button onClick={handleApply} type='primary' disabled={disabled}>
        {getI18n('general.apply')}
      </Button>
    </div>
  );

  return (
    <Fragment>
      <Drawer
        className={css.drawer}
        width={420}
        title={replaceI18nVariables(
          getI18n(`reports.reportdetailcomponents.configDrawer.report_text`),
          text,
        )}
        placement='right'
        onClose={onClose}
        destroyOnClose
        footer={drawerFooter}
        visible={visible}>
        <Input
          size='large'
          onChange={handleOnChange}
          allowClear
          suffix={<Icon type='iconsearch' disabled={disabled} />}
        />
        <OriCheckboxGroup value={checkedList} className={css.oriCheckboxGroup}>
          {(valueList || []).map((item, index) => (
            <OriCheckbox
              className={css.oriCheckbox}
              disabled={item.disabled || disabled}
              value={item.header}
              onChange={() => handleCheckChange(item.header)}
              key={index}>
              {item.header}
            </OriCheckbox>
          ))}
        </OriCheckboxGroup>
      </Drawer>
      <Button type='primary' ghost onClick={showDrawer} disabled={disabled}>
        {text}
      </Button>
    </Fragment>
  );
};

export default ConfigDrawer;
